import React from 'react';
import {
    Row,
    Col,
    Button,
    Tabs,
    Nav,
    Tab,
    Table,
    Modal,
    Container,
    FormFile,
    Form
} from "react-bootstrap";
import Switch from "react-switch";
class CategoryEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: {
                name: this.props.ItemList.name,
                desc: this.props.ItemList.desc,
                code: this.props.ItemList.code,
                iconurl: null,
                parent: this.props.ItemList.parent,
                isActive: this.props.ItemList.isActive,

            }
        };
        this.submit = this.submit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleChange = this.handleChange.bind(this);
        this.toogileChange = this.toogileChange.bind(this)
    }
    submit() {



    }
    onChange(value) {
        let field = value.target.name
        let data = value.target.value
        if (field == "name") {
            this.setState({
                value: { ...this.state.value, name: data }
            })
        } else if (field == "Desc") {
            this.setState({
                value: { ...this.state.value, desc: data }
            })
        } else if (field == "code") {
            this.setState({
                value: { ...this.state.value, code: data }
            })
        }

    }
    fileChangedHandler = (event) => {
        const icon = event.target.files[0]

        this.setState({
            value: { ...this.state.value, iconurl: icon }
        })
    }
    handleChange(checked) {
        this.setState({ value: { ...this.state.value, isActive: checked } });
    }
    toogileChange(checked) {
        this.setState({ value: { ...this.state.value, parent: checked } });
    }
    closeModal() {
        this.props.handleClose();
    }
    render() {
        console.log("item===", this.props.ItemList)
        return <div>
            <Modal show={this.props.editShow} size="lg" onHide={this.props.closemodel}>
                <Modal.Header closeButton>
                    <Modal.Title>Category
</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group controlId="name">
                                        <Form.Label> Name</Form.Label>
                                        <Form.Control type="text" placeholder="Name" autocomplete="off" name="name" onChange={this.onChange} value={this.state.value.name || ''} />

                                    </Form.Group>
                                </Col>
                                <Col lg={6}>

                                    <Form.Group controlId="Description">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control as="textarea" name="Desc" autocomplete="off" onChange={this.onChange} value={this.state.value.desc} />
                                    </Form.Group>

                                </Col>
                            </Row>


                            <Row>
                                <Col lg={6}>
                                    <Form.Group controlId="code">
                                        <Form.Label> Code</Form.Label>
                                        <Form.Control type="text" placeholder="Code" autocomplete="off" name="code" onChange={this.onChange} value={this.state.value.code} />

                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group>
                                        <Form.Label> IconUrl</Form.Label>
                                        <Form.File id="exampleFormControlFile1" name="icon" onChange={this.fileChangedHandler} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <label>

                                        <span>Active</span>
                                        <Switch onChange={this.handleChange} onColor="#20a8d8" checked={this.state.value.isActive} />
                                    </label>
                                </Col>
                                <Col lg={6}>
                                    <label>
                                        <span>Parent</span>
                                        <Switch onChange={this.toogileChange} onColor="#20a8d8" checked={this.state.value.parent} />
                                    </label>


                                </Col>
                            </Row>

                        </Form>

                    </Container>
                </Modal.Body>
                <Modal.Footer>


                </Modal.Footer>
            </Modal>
        </div>;
    }
}



export default CategoryEdit;

